import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AuditLogsPage } from "@/features/operator/AuditLogsPage";

export const Route = createFileRoute("/app/operator/audit-logs")({
  validateSearch: z.object({
    action: z.string().optional(),
    resource: z.string().optional(),
    outcome: z.string().optional(),
  }),
  component: AuditLogsPage,
});
